export const createErrorWrapper = (code, defaultMessage) => info => ({
  code,
  message: info.response ? (info.response.data || defaultMessage) : defaultMessage,
  info,
});
